<!-- PAGE CONTENT WRAPPER -->
<div class="page-content-wrap contentdata">
  <div class="row">
    <div class="col-md-12">

      <div class="page-breadcrumb">
        <ul class="page-breadcrumb__trail">
          <li><a>Manage</a></li>
          <li><a>Devices</a></li>         
          <li *ngIf="!iscmorfp"><a>Farm Assignments</a></li>
          <li *ngIf="iscmorfp"><a>Pond Assignments</a></li>
        </ul>
      </div>
      
      <div class="block">
        <p class="assigndevice">Assign Device Number -- {{deviceNumber}}</p>
        <div class="row" *ngIf="iscmorfp=='false' && (businessEntities && businessEntities.length == 0)">
          <p class="nofarm">No Farms are available</p>
        </div>
        <div class="row row-flex">
          <div class="col-md-3 col-sm-6 col-xs-12" *ngFor="let list of businessEntities">
            <div class="content colour-1">
              <span class="farmname">{{list.businessName}}<span style="float: right">
                <input name="selectedbusinessid" value="{{list.id}}" [(ngModel)]="businessEntitie.id" class="radiocheck" type="radio"></span></span>
              <p style="color: #000; margin-top: 15px;" *ngFor="let devices of list.CustomerDevice">
                {{devices && devices.device && devices.device.number}}
              </p>
              <p style="margin-top: 15px; color: #000;"
                 *ngIf="(list && list.CustomerDevice && list.CustomerDevice.length)==0"> No devices</p>
            </div>
          </div>
        </div>
        <div class="col-lg-12" *ngIf="iscmorfp=='false' && (businessEntities && businessEntities.length > 0) ">
          <button class="btn btn-info pull-right" (click)="assignDeviceToFarmId()">Submit</button>
        </div>

        <!--Cms selection-->
        <div class="row" *ngIf="iscmorfp=='true' && (farmsites && farmsites.length == 0) && businessType == 'Farm'">
          <p class="nofarm">No Farm sites are available</p>
        </div>
        <div class="row" *ngIf="iscmorfp=='true' && (businessEntities && businessEntities.length == 0) && businessType != 'Farm'">
          <p class="nofarm">No Farms are available</p>
        </div>
        <div class="block" *ngIf="iscmorfp=='true' && ((farmsites && farmsites.length > 0) || (businessEntities && businessEntities.length > 0))">
          <form role="form" name="addmapdevice" (ngSubmit)="assignDeviceToFarmId()">
            <div class="row top-field">
              <div class="col-md-6" *ngIf="businessType == 'Feed Provider' || businessType == 'Seed Provider'">
                <div class="form-group cursor-pointer">
                  <label class="control-label">Business Name</label>
                  <select name="business" [(ngModel)]="businessEntitie.id" class="form-control"
                          *ngIf="loginPersonType != 'Farmer' && loginPersonType != 'Farm Manager'"
                          (change)="getAllstedetailsByBusinessId()" required>
                    <option value="" disabled selected>Select Business</option>
                    <option value="{{business.id}}"
                            *ngFor="let business of businessEntities">{{business.businessName}}</option>
                  </select>
                  <span class="caret history-caret"
                        *ngIf="loginPersonType != 'Farmer' && loginPersonType != 'Farm Manager'"></span>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group cursor-pointer">
                  <label class="control-label">Farm Site</label>
                  <select name="devicenumber" [(ngModel)]="farmsite.id" class="form-control"
                          (change)="getAllPondDetailsByFarmsiteId()" required>
                    <option value="" disabled selected>Select Farmsite</option>
                    <option value="{{farmSite.id}}"
                            *ngFor="let farmSite of farmsites">{{farmSite.farmNameAtLocation}}</option>
                  </select>
                  <span class="caret history-caret"></span>
                </div>
              </div>
            </div>
            <div class="row top-field">
              <div class="col-md-6">
                <div class="form-group cursor-pointer">
                  <label class="control-label">Pond</label>
                  <select name="devicenumber" [(ngModel)]="customerPond.id" class="form-control"
                          required>
                    <option value="" disabled selected>Select Pond</option>
                    <option value="{{pond.id}}"
                            *ngFor="let pond of customerPonds">{{pond.name}}</option>
                  </select>
                  <span class="caret history-caret"></span>
                  <p style="color: red;" *ngIf="(customerPonds && customerPonds.length == 0)">No pond available for this
                    site</p>
                </div>
              </div>
            </div>

            <div class="col-lg-12" *ngIf="((farmsites && farmsites.length > 0) || businessEntitie && businessEntities.length > 0)">
              <button id="culturesummaryreportsearch" class="mapdevice_submit btn btn-info pull-right update btn_color"
                      type="submit">Submit
              </button>
            </div>
          </form>
        </div>
        <!-- END FORM VALIDATION STATES -->
      </div>
    </div>
  </div>
</div>
